// Algebra tile icons for two-step equation types
// Tall x-bars + unit squares, darker fill = negative tiles
const TILE_ICONS = {
  // ax + b = c: x-bars + positive units = more units
  coeffPlus: `<svg viewBox="0 0 60 48" fill="none" stroke="#374151" stroke-width="1.5"><line x1="29" y1="20" x2="33" y2="20"/><line x1="29" y1="25" x2="33" y2="25"/><rect x="2" y="11" width="7" height="24" rx="2" fill="#374151" fill-opacity="0.06"/><text x="5.5" y="26" font-size="6" font-family="serif" font-style="italic" fill="#374151" stroke="none" text-anchor="middle">x</text><rect x="10.5" y="11" width="7" height="24" rx="2" fill="#374151" fill-opacity="0.06"/><text x="14" y="26" font-size="6" font-family="serif" font-style="italic" fill="#374151" stroke="none" text-anchor="middle">x</text><rect x="20" y="15" width="6" height="6" rx="1"/><rect x="20" y="24" width="6" height="6" rx="1"/><rect x="36" y="11" width="7" height="7" rx="1"/><rect x="45" y="11" width="7" height="7" rx="1"/><rect x="36" y="20" width="7" height="7" rx="1"/><rect x="45" y="20" width="7" height="7" rx="1"/><rect x="36" y="29" width="7" height="7" rx="1"/><rect x="45" y="29" width="7" height="7" rx="1"/></svg>`,
  // ax − b = c: x-bars + negative (dark) units = positive units
  coeffMinus: `<svg viewBox="0 0 60 48" fill="none" stroke="#374151" stroke-width="1.5"><line x1="29" y1="20" x2="33" y2="20"/><line x1="29" y1="25" x2="33" y2="25"/><rect x="2" y="11" width="7" height="24" rx="2" fill="#374151" fill-opacity="0.06"/><text x="5.5" y="26" font-size="6" font-family="serif" font-style="italic" fill="#374151" stroke="none" text-anchor="middle">x</text><rect x="10.5" y="11" width="7" height="24" rx="2" fill="#374151" fill-opacity="0.06"/><text x="14" y="26" font-size="6" font-family="serif" font-style="italic" fill="#374151" stroke="none" text-anchor="middle">x</text><rect x="20" y="15" width="6" height="6" rx="1" fill="#374151" fill-opacity="0.2"/><rect x="20" y="24" width="6" height="6" rx="1" fill="#374151" fill-opacity="0.2"/><rect x="36" y="11" width="7" height="7" rx="1"/><rect x="45" y="11" width="7" height="7" rx="1"/><rect x="36" y="20" width="7" height="7" rx="1"/><rect x="45" y="20" width="7" height="7" rx="1"/><rect x="36" y="29" width="7" height="7" rx="1"/></svg>`,
  // x/a + b = c: split x-bar + positive units = units
  divPlus: `<svg viewBox="0 0 60 48" fill="none" stroke="#374151" stroke-width="1.5"><line x1="29" y1="20" x2="33" y2="20"/><line x1="29" y1="25" x2="33" y2="25"/><rect x="3" y="11" width="10" height="24" rx="2" fill="#374151" fill-opacity="0.06"/><text x="8" y="26" font-size="8" font-family="serif" font-style="italic" fill="#374151" stroke="none" text-anchor="middle">x</text><line x1="3" y1="23" x2="13" y2="23" stroke-dasharray="1.5 1.5" opacity="0.4"/><rect x="16" y="15" width="6" height="6" rx="1"/><rect x="16" y="24" width="6" height="6" rx="1"/><rect x="36" y="11" width="7" height="7" rx="1"/><rect x="45" y="11" width="7" height="7" rx="1"/><rect x="36" y="20" width="7" height="7" rx="1"/><rect x="45" y="20" width="7" height="7" rx="1"/><rect x="36" y="29" width="7" height="7" rx="1"/><rect x="45" y="29" width="7" height="7" rx="1"/></svg>`,
  // −ax + b = −c: dark x-bars + positive units = dark units
  negCoeff: `<svg viewBox="0 0 60 48" fill="none" stroke="#374151" stroke-width="1.5"><line x1="29" y1="20" x2="33" y2="20"/><line x1="29" y1="25" x2="33" y2="25"/><rect x="2" y="11" width="7" height="24" rx="2" fill="#374151" fill-opacity="0.2"/><text x="5.5" y="26" font-size="6" font-family="serif" font-style="italic" fill="#374151" stroke="none" text-anchor="middle">x</text><rect x="10.5" y="11" width="7" height="24" rx="2" fill="#374151" fill-opacity="0.2"/><text x="14" y="26" font-size="6" font-family="serif" font-style="italic" fill="#374151" stroke="none" text-anchor="middle">x</text><rect x="20" y="15" width="6" height="6" rx="1"/><rect x="20" y="24" width="6" height="6" rx="1"/><rect x="39" y="16" width="7" height="7" rx="1" fill="#374151" fill-opacity="0.2"/><rect x="39" y="27" width="7" height="7" rx="1" fill="#374151" fill-opacity="0.2"/></svg>`,
};

new GuidedTopics.EquationSolverPage({
  pageId: 'two-step-equations',
  title: 'Two-Step Equations',
  guideUrl: 'two-step-equations-guide.html',
  presets: {
    'preset-1': {
      id: 'preset-1',
      name: '2x + 3 = 11',
      icon: TILE_ICONS.coeffPlus,
      expressions: [],
      equations: ['2x + 3 = 11'],
    },
    'preset-2': {
      id: 'preset-2',
      name: '5x − 10 = 15',
      icon: TILE_ICONS.coeffMinus,
      expressions: [],
      equations: ['5x - 10 = 15'],
    },
    'preset-3': {
      id: 'preset-3',
      name: '4x + 7 = 3',
      icon: TILE_ICONS.coeffPlus,
      expressions: [],
      equations: ['4x + 7 = 3'],
    },
    'preset-4': {
      id: 'preset-4',
      name: 'x/2 + 3 = 7',
      icon: TILE_ICONS.divPlus,
      expressions: [],
      equations: ['x / 2 + 3 = 7'],
    },
    'preset-5': {
      id: 'preset-5',
      name: '3x − 1 = 8',
      icon: TILE_ICONS.coeffMinus,
      expressions: [],
      equations: ['3x - 1 = 8'],
    },
    'preset-challenge': {
      id: 'preset-challenge',
      name: '\u22123x + 7 = \u22128',
      icon: TILE_ICONS.negCoeff,
      expressions: [],
      equations: ['-3x + 7 = -8'],
    },
    'preset-right': {
      id: 'preset-right',
      name: '11 = 2x + 3',
      icon: TILE_ICONS.coeffPlus,
      expressions: [],
      equations: ['11 = 2x + 3'],
    },
  },
  headerPresets: [],
  wizard: {
    title: 'Create Two-Step Equation',
    subtitle: 'Choose the equation form:',
    typeCards: {
      'coeff-plus': {
        name: 'Multiply & Add',
        icon: 'ax + b = c',
        examples: ['3x + 5 = 14', '2x + 1 = 9'],
      },
      'coeff-minus': {
        name: 'Multiply & Subtract',
        icon: 'ax \u2212 b = c',
        examples: ['5x \u2212 10 = 15', '4x \u2212 3 = 1'],
      },
      'div-plus': {
        name: 'Divide & Add',
        icon: 'x/a + b = c',
        examples: ['x/2 + 3 = 7', 'x/4 + 1 = 5'],
      },
      'div-minus': {
        name: 'Divide & Subtract',
        icon: 'x/a \u2212 b = c',
        examples: ['x/3 \u2212 2 = 4', 'x/5 \u2212 1 = 3'],
      },
    },
    typeOrder: ['coeff-plus', 'coeff-minus', 'div-plus', 'div-minus'],
    entryTemplates: {
      'coeff-plus': {
        expression: '\\numberbox x + \\numberbox = \\numberbox',
        slots: [
          {
            id: 'coefficient',
            label: 'coefficient',
            type: 'integer',
            allowNegative: false,
            exclude: [0, 1],
          },
          { id: 'constant', label: 'constant', type: 'integer', allowNegative: false },
          { id: 'result', label: 'result', type: 'integer', allowNegative: true },
        ],
      },
      'coeff-minus': {
        expression: '\\numberbox x - \\numberbox = \\numberbox',
        slots: [
          {
            id: 'coefficient',
            label: 'coefficient',
            type: 'integer',
            allowNegative: false,
            exclude: [0, 1],
          },
          { id: 'constant', label: 'constant', type: 'integer', allowNegative: false },
          { id: 'result', label: 'result', type: 'integer', allowNegative: true },
        ],
      },
      'div-plus': {
        expression: 'x / \\numberbox + \\numberbox = \\numberbox',
        slots: [
          {
            id: 'divisor',
            label: 'divisor',
            type: 'integer',
            allowNegative: false,
            exclude: [0],
          },
          { id: 'constant', label: 'constant', type: 'integer', allowNegative: false },
          { id: 'result', label: 'result', type: 'integer', allowNegative: true },
        ],
      },
      'div-minus': {
        expression: 'x / \\numberbox - \\numberbox = \\numberbox',
        slots: [
          {
            id: 'divisor',
            label: 'divisor',
            type: 'integer',
            allowNegative: false,
            exclude: [0],
          },
          { id: 'constant', label: 'constant', type: 'integer', allowNegative: false },
          { id: 'result', label: 'result', type: 'integer', allowNegative: true },
        ],
      },
    },
    buildEquation: (type, values) => {
      switch (type) {
        case 'coeff-plus':
          return `${values.coefficient}x + ${values.constant} = ${values.result}`;
        case 'coeff-minus':
          return `${values.coefficient}x - ${values.constant} = ${values.result}`;
        case 'div-plus':
          return `x / ${values.divisor} + ${values.constant} = ${values.result}`;
        case 'div-minus':
          return `x / ${values.divisor} - ${values.constant} = ${values.result}`;
        default:
          return 'x = 0';
      }
    },
  },
}).init();
